import { useState } from 'react';
import Layout from '@/components/layout/Layout';
import TripPlannerWizard from '@/components/TripPlannerWizard';
import { Seo } from '@/components/Seo';
import { cn } from '@/lib/utils';

const TripPlanner = () => {
  // Mobile-only: once results are showing, the "Plan Your Surf Trip" intro
  // is redundant and just pushes the actual recommendations further down a
  // phone screen. Desktop/tablet keep it regardless of wizard state.
  const [showingResults, setShowingResults] = useState(false);

  return (
    <Layout>
      <Seo
        title="Surf Trip Planner | Match Your Ability, Budget and Travel Style"
        description="Answer a few practical questions and compare surf destinations suited to your dates, surf level, budget and preferred type of trip."
        path="/trip-planner"
      />
      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 md:py-24 lg:py-32">
        <div className="container mx-auto px-4">
          {/* Header - Larger, more impactful */}
          <div
            className={cn(
              'text-center mb-8 md:mb-12 lg:mb-16',
              showingResults && 'hidden md:block',
            )}
          >
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-semibold text-foreground mb-4 md:mb-6">
              Plan Your Surf Trip
            </h1>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed px-4">
              Answer a few questions and we'll match you with the perfect surf destinations around the world
            </p>
          </div>

          {/* Wizard */}
          <TripPlannerWizard onResultsChange={setShowingResults} />
        </div>
      </section>

      {/* Spacer */}
      <div className="h-12" />
    </Layout>
  );
};

export default TripPlanner;
